module.exports = __webpack_public_path__ + "img/zx-share-poster.9f004bf3.png";